import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { Button } from '../../Button/Button.js';
import { ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY } from '../IconInput.meta.js';

export default InjectedStyledComponent(Button, ICON_INPUT_CATEGORY_KEY, ICON_INPUT_COMPONENT_KEY, ['clearButton']);
